import React, { Component } from 'react';
import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';

class ErrorBoundary extends Component {
  state = { hasError: false };

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    console.error(error, info);
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      //fallback UI
      return (
        <Result
          status="500"
          title="500"
          subTitle="页面出错了, 请联系管理员"
          extra={
            <Link to="/">
              <Button type="primary">返回首页</Button>
            </Link>
          }
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
